export const groupNameOptions = [
  {
    key: 0,
    value: 0,
    text: 'All Groups',
  },
  {
    key: 1,
    value: 'Inventory',
    text: 'Inventory',
  },
  {
    key: 2,
    value: 'Reports',
    text: 'Reports',
  },
];
export const subGroupNameOptions = [
  {
    key: 0,
    value: 0,
    text: 'All SubGroups',
  },
  {
    key: 1,
    value: 'Orders',
    text: 'Orders',
  },
  {
    key: 2,
    value: 'Transactions',
    text: 'Transactions',
  },
  {
    key: 3,
    value: 'Inventory',
    text: 'Inventory',
  },
];



// WEBPACK FOOTER //
// ./src/common/Constants/groupNames.js